import { render, staticRenderFns } from "./addOrgaManager.vue?vue&type=template&id=eac23ae6&scoped=true"
import script from "./addOrgaManager.vue?vue&type=script&lang=js"
export * from "./addOrgaManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eac23ae6",
  null
  
)

export default component.exports